export const MAX_USER_AVATAR_FILE_SIZE_MB = 2;
export const MAX_USER_AVATAR_FILE_SIZE_BYTES =
    MAX_USER_AVATAR_FILE_SIZE_MB * 1024 * 1024;
